import React, {Component} from 'react';
import icons from '../../common/icons.svg';

class Iconizer extends Component {

	constructor(props) {
		super(props);

		this.state={};
	}

	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg"
				 xmlnsXlink="http://www.w3.org/1999/xlink"
				 height={this.props.height}
				 width={this.props.width}
				 fill={this.props.fill}
				 style={this.props.style}
				 floodColor={this.props.color?this.props.color:"#000000"}
				 onClick={() => this.props.actionMethod &&  this.props.actionMethod(this.props.actionParam)}>
				<use xlinkHref={`${icons}#${this.props.name}`} />
			</svg>
		)
	}
}

export default Iconizer;